
import { Movie } from '../types';

// Hardcoded key used ONLY for search queries on the client
const TMDB_API_KEY = 'ab6949f35e196f51d836afac3f32b465'; 
const BASE_URL = 'https://api.themoviedb.org/3';

const handleResponse = async (res: Response) => {
  if (res.status === 401) {
    throw new Error("Invalid TMDB API Key.");
  }
  if (!res.ok) {
    const errorText = await res.text();
    console.error('SERVER ERROR (handleResponse):', errorText);
    const errorData = JSON.parse(errorText || '{}');
    throw new Error(errorData.status_message || errorData.error || `Request failed with status ${res.status}`);
  }
  return res.json();
};

/**
 * Proxies through local /api/movie for full movie hydration.
 * This hides our API key and ensures the backend logic is applied.
 */
export const getMovieById = async (id: number, lang: string): Promise<Movie> => {
  try {
    // Strictly absolute path
    const res = await fetch(`/api/movie?id=${id}&lang=${lang}`);
    return await handleResponse(res);
  } catch (error) {
    console.error("Local API getMovieById error:", error);
    throw error;
  }
};

/**
 * Proxies through local /api/movie to get validated frames.
 */
export const getMovieImages = async (id: number): Promise<string[]> => {
  try {
    // Strictly absolute path
    const res = await fetch(`/api/movie?id=${id}`);
    const data = await handleResponse(res);
    return data.images || [];
  } catch (error) {
    console.error("Local API getMovieImages error:", error);
    return [];
  }
};

/**
 * Search hitting TMDB directly is fine for performance, 
 * but still uses the public-facing key.
 */
export const searchMovies = async (query: string, lang: string): Promise<Movie[]> => {
  if (!query || query.length < 2) return [];
  try {
    const res = await fetch(
      `${BASE_URL}/search/movie?api_key=${TMDB_API_KEY}&query=${encodeURIComponent(query)}&language=${lang}`
    );
    const data = await handleResponse(res);
    return (data.results || []).slice(0, 8);
  } catch (error) {
    console.error("TMDB searchMovies error:", error);
    return [];
  }
};
